export default __webpack_public_path__ + "static/media/clbrk_logo.745687de.svg";